<div class="contenedor-tabla">
    <mat-table
        class="comunas"
        #table
        [dataSource]="dataSource"
        [@animateStagger]="{ value: '50' }"
        fusePerfectScrollbar
    >
        <ng-container matColumnDef="nombre">
            <mat-header-cell *matHeaderCellDef>Nombre</mat-header-cell>
            <mat-cell *matCellDef="let servicio">
                {{ servicio.descripcion }}
            </mat-cell>
        </ng-container>

        <ng-container
            *ngFor="let atributo of atributos; let i = index"
            matColumnDef="{{ atributo.descripcion }}"
        >
            <mat-header-cell *matHeaderCellDef>{{
                atributo.descripcion
            }}</mat-header-cell>
            <mat-cell *matCellDef="let servicio">
                {{ servicio.atributos[i] }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="medida">
            <mat-header-cell *matHeaderCellDef>Medida</mat-header-cell>
            <mat-cell *matCellDef="let servicio">
                {{ servicio.unidadMedida.descripcion }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tiempo">
            <mat-header-cell *matHeaderCellDef>Tiempo</mat-header-cell>
            <mat-cell *matCellDef="let servicio">
                {{
                    servicio.unidadTiempo
                        ? servicio.unidadTiempo.descripcion
                        : "N/A"
                }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="precio">
            <mat-header-cell *matHeaderCellDef>Valor UF</mat-header-cell>
            <mat-cell *matCellDef="let servicio">
                UF {{ servicio.precioDesde }} - UF {{ servicio.precioHasta }}
                <button
                    mat-icon-button
                    type="button"
                    color="accent"
                    (click)="cambiarPrecio(servicio)"
                >
                    <mat-icon>edit</mat-icon>
                </button>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="borrar">
            <mat-header-cell *matHeaderCellDef>Borrar</mat-header-cell>
            <mat-cell *matCellDef="let servicio">

                <button
                mat-icon-button
                type="button"
                color="accent"
                (click)="borrar(servicio)">
                <mat-icon>delete</mat-icon>
            </button>

            </mat-cell>
        </ng-container>

        <!-- ng-container matColumnDef="guardar">
            <mat-header-cell *matHeaderCellDef>Guardar</mat-header-cell>
            <mat-cell *matCellDef="let servicio">
                <button
                    mat-icon-button
                    type="button"
                    color="accent"
                    (click)="cambiarPrecio(servicio)"
                >
                    <mat-icon>save</mat-icon>
                </button>
            </mat-cell>
        </ng-container -->

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let comuna; columns: displayedColumns"> </mat-row>
    </mat-table>
</div>
